// FlexCo Mock Data - Multilingual Content

export const translations = {
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      benefits: 'Benefits',
      team: 'Team',
      insights: 'Insights',
      contact: 'Contact',
    },
    hero: {
      tagline: 'Your Gateway to European Markets',
      title: 'Innovative Capital Solutions',
      subtitle: 'Through Austrian FlexCo',
      description: 'Unlock growth capital, access EU funding, and expand into German-speaking markets with our expert consulting team.',
      cta1: 'Book Consultation',
      cta2: 'Contact Us',
    },
    services: {
      sectionTag: 'What We Offer',
      title: 'Our Services',
      subtitle: 'Comprehensive solutions for your business growth in the European market',
      items: [
        {
          id: 1,
          icon: 'Building2',
          title: 'Company Formation',
          description: 'Establish your Austrian FlexCo with full legal compliance and minimal administrative burden.',
        },
        {
          id: 2,
          icon: 'TrendingUp',
          title: 'Capital Raising',
          description: 'Access innovative UWA-based funding without losing control of your company.',
        },
        {
          id: 3,
          icon: 'Briefcase',
          title: 'Corporate Advisory',
          description: 'Strategic guidance for market entry, growth planning, and business development.',
        },
        {
          id: 4,
          icon: 'Target',
          title: 'Strategic Consulting',
          description: 'Tailored strategies for sustainable growth and competitive advantage.',
        },
        {
          id: 5,
          icon: 'FileCheck',
          title: 'Due Diligence',
          description: 'Comprehensive financial, legal, and operational due diligence services.',
        },
        {
          id: 6,
          icon: 'Handshake',
          title: 'M&A Advisory',
          description: 'Expert support for mergers, acquisitions, and corporate transactions.',
        },
      ],
    },
    benefits: {
      sectionTag: 'Why FlexCo',
      title: 'FlexCo Advantages',
      subtitle: 'The innovative Austrian company form designed for modern business needs',
      items: [
        { icon: 'Wallet', title: 'Low Share Capital', description: 'Start with minimal capital requirements' },
        { icon: 'Shield', title: 'Legal Security', description: 'Austrian legal framework protection' },
        { icon: 'Globe', title: 'DACH Market Access', description: 'Direct access to German-speaking markets' },
        { icon: 'Euro', title: 'EU Funding Access', description: 'Easier access to European funding' },
        { icon: 'FileText', title: 'Simplified Admin', description: 'Reduced bureaucracy and paperwork' },
        { icon: 'Users', title: 'Flexible Structure', description: 'Adaptable corporate governance' },
        { icon: 'PiggyBank', title: 'Tax Benefits', description: 'No trade tax, favorable tax treaties' },
        { icon: 'Zap', title: 'Fast Setup', description: 'Quick and efficient company formation' },
      ],
      uwa: {
        tag: 'Innovation',
        title: 'UWA - The Future of Startup Funding',
        description: 'Unternehmenswert-Anteil (UWA) is a revolutionary equity-based share that enables flexible capital raising while founders retain full control.',
        features: [
          'No notary required for issuance',
          'Maximum 50% voting cap protects founders',
          'Independent of share capital amount',
          'Fast and cost-effective process',
        ],
      },
    },
    team: {
      sectionTag: 'Our Experts',
      title: 'Meet Our Team',
      subtitle: 'Experienced professionals dedicated to your success',
      members: [
        {
          id: 1,
          name: 'Tibor Mészáros',
          role: 'International Capital Raising',
          description: 'Expert in cross-border financing and investor relations',
        },
        {
          id: 2,
          name: 'Dr. Ferenc Rosner',
          role: 'International Corporate Law',
          description: 'Specialist in Austrian and EU business law',
        },
        {
          id: 3,
          name: 'László Biró',
          role: 'Lead Corporate Expert',
          description: 'Senior advisor for strategic business development',
        },
      ],
    },
    testimonials: {
      sectionTag: 'Success Stories',
      title: 'Client Testimonials',
      subtitle: 'What our clients say about working with us',
      items: [
        {
          id: 1,
          quote: 'FlexCo Consulting helped us raise €800,000 in growth capital while maintaining full control of our company. Their UWA expertise is unmatched.',
          author: 'CEO, Tech Startup',
          company: 'Vienna',
        },
        {
          id: 2,
          quote: 'The team guided us through every step of establishing our Austrian presence. Professional, efficient, and truly dedicated.',
          author: 'Founder',
          company: 'Budapest',
        },
        {
          id: 3,
          quote: 'Access to EU funding became straightforward with their expert guidance. Highly recommend for any CEE company looking to expand.',
          author: 'Managing Director',
          company: 'Berlin',
        },
      ],
    },
    insights: {
      sectionTag: 'Knowledge Hub',
      title: 'Market Insights',
      subtitle: 'Stay informed with our latest articles and market analysis',
      articles: [
        {
          id: 1,
          title: 'Asset Contribution and Holding Structures',
          excerpt: 'Understanding apport and how to optimize your holding structure for maximum efficiency.',
          author: 'László Biró',
          date: '2025-01-15',
          readTime: '5 min',
        },
        {
          id: 2,
          title: 'Capital Raising Strategies with FlexCo',
          excerpt: 'Discover innovative approaches to securing growth capital through the Austrian FlexCo framework.',
          author: 'Tibor Mészáros',
          date: '2025-01-10',
          readTime: '7 min',
        },
        {
          id: 3,
          title: 'Entering the DACH Market',
          excerpt: 'A comprehensive guide for CEE companies looking to expand into German-speaking markets.',
          author: 'Dr. Ferenc Rosner',
          date: '2025-01-05',
          readTime: '6 min',
        },
      ],
    },
    contact: {
      sectionTag: 'Get in Touch',
      title: 'Start Your Journey',
      subtitle: 'Ready to unlock your business potential? Contact us today.',
      form: {
        name: 'Full Name',
        email: 'Email Address',
        company: 'Company Name',
        phone: 'Phone Number',
        message: 'Your Message',
        submit: 'Send Message',
        success: 'Thank you! We will contact you shortly.',
      },
      booking: {
        title: 'Book a Consultation',
        description: 'Schedule a free 30-minute consultation with our experts.',
        cta: 'Schedule Now',
      },
      info: {
        email: 'info@flexco.hu',
        phone: '+43 1 234 5678',
        address: 'Vienna, Austria',
      },
    },
    footer: {
      description: 'Your trusted partner for Austrian company formation and capital raising solutions.',
      links: {
        services: 'Services',
        about: 'About Us',
        contact: 'Contact',
        privacy: 'Privacy Policy',
        terms: 'Terms of Service',
      },
      copyright: '© 2025 FlexCo Consulting. All rights reserved.',
    },
  },
  de: {
    nav: {
      home: 'Startseite',
      services: 'Leistungen',
      benefits: 'Vorteile',
      team: 'Team',
      insights: 'Einblicke',
      contact: 'Kontakt',
    },
    hero: {
      tagline: 'Ihr Tor zu europäischen Märkten',
      title: 'Innovative Kapitallösungen',
      subtitle: 'Durch österreichische FlexCo',
      description: 'Erschließen Sie Wachstumskapital, erhalten Sie Zugang zu EU-Fördermitteln und expandieren Sie in deutschsprachige Märkte mit unserem Expertenteam.',
      cta1: 'Beratung buchen',
      cta2: 'Kontakt aufnehmen',
    },
    services: {
      sectionTag: 'Unser Angebot',
      title: 'Unsere Leistungen',
      subtitle: 'Umfassende Lösungen für Ihr Unternehmenswachstum im europäischen Markt',
      items: [
        {
          id: 1,
          icon: 'Building2',
          title: 'Firmengründung',
          description: 'Gründen Sie Ihre österreichische FlexCo mit vollständiger rechtlicher Compliance.',
        },
        {
          id: 2,
          icon: 'TrendingUp',
          title: 'Kapitalbeschaffung',
          description: 'Zugang zu innovativer UWA-basierter Finanzierung ohne Kontrollverlust.',
        },
        {
          id: 3,
          icon: 'Briefcase',
          title: 'Unternehmensberatung',
          description: 'Strategische Beratung für Markteintritt und Geschäftsentwicklung.',
        },
        {
          id: 4,
          icon: 'Target',
          title: 'Strategieberatung',
          description: 'Maßgeschneiderte Strategien für nachhaltiges Wachstum.',
        },
        {
          id: 5,
          icon: 'FileCheck',
          title: 'Due Diligence',
          description: 'Umfassende finanzielle, rechtliche und operative Prüfungen.',
        },
        {
          id: 6,
          icon: 'Handshake',
          title: 'M&A Beratung',
          description: 'Expertenunterstützung bei Fusionen und Übernahmen.',
        },
      ],
    },
    benefits: {
      sectionTag: 'Warum FlexCo',
      title: 'FlexCo Vorteile',
      subtitle: 'Die innovative österreichische Unternehmensform für moderne Geschäftsanforderungen',
      items: [
        { icon: 'Wallet', title: 'Niedriges Stammkapital', description: 'Starten Sie mit minimalen Kapitalanforderungen' },
        { icon: 'Shield', title: 'Rechtssicherheit', description: 'Schutz durch österreichisches Rechtssystem' },
        { icon: 'Globe', title: 'DACH-Marktzugang', description: 'Direkter Zugang zu deutschsprachigen Märkten' },
        { icon: 'Euro', title: 'EU-Förderungen', description: 'Einfacherer Zugang zu europäischen Mitteln' },
        { icon: 'FileText', title: 'Vereinfachte Verwaltung', description: 'Reduzierte Bürokratie' },
        { icon: 'Users', title: 'Flexible Struktur', description: 'Anpassbare Unternehmensführung' },
        { icon: 'PiggyBank', title: 'Steuervorteile', description: 'Keine Gewerbesteuer, günstige Abkommen' },
        { icon: 'Zap', title: 'Schnelle Gründung', description: 'Effiziente Firmengründung' },
      ],
      uwa: {
        tag: 'Innovation',
        title: 'UWA - Die Zukunft der Startup-Finanzierung',
        description: 'Der Unternehmenswert-Anteil (UWA) ist eine revolutionäre Beteiligungsform, die flexible Kapitalbeschaffung ermöglicht.',
        features: [
          'Kein Notar für Ausgabe erforderlich',
          'Maximale 50% Stimmrechtsgrenze schützt Gründer',
          'Unabhängig vom Stammkapital',
          'Schneller und kosteneffizienter Prozess',
        ],
      },
    },
    team: {
      sectionTag: 'Unsere Experten',
      title: 'Unser Team',
      subtitle: 'Erfahrene Fachleute für Ihren Erfolg',
      members: [
        {
          id: 1,
          name: 'Tibor Mészáros',
          role: 'Internationale Kapitalbeschaffung',
          description: 'Experte für grenzüberschreitende Finanzierung',
        },
        {
          id: 2,
          name: 'Dr. Ferenc Rosner',
          role: 'Internationales Unternehmensrecht',
          description: 'Spezialist für österreichisches und EU-Wirtschaftsrecht',
        },
        {
          id: 3,
          name: 'László Biró',
          role: 'Leitender Unternehmensexperte',
          description: 'Senior Berater für strategische Geschäftsentwicklung',
        },
      ],
    },
    testimonials: {
      sectionTag: 'Erfolgsgeschichten',
      title: 'Kundenstimmen',
      subtitle: 'Was unsere Kunden über die Zusammenarbeit sagen',
      items: [
        {
          id: 1,
          quote: 'FlexCo Consulting half uns, 800.000€ Wachstumskapital zu beschaffen und dabei die volle Kontrolle zu behalten.',
          author: 'CEO, Tech Startup',
          company: 'Wien',
        },
        {
          id: 2,
          quote: 'Das Team begleitete uns bei jedem Schritt der Gründung unserer österreichischen Präsenz. Professionell und effizient.',
          author: 'Gründer',
          company: 'Budapest',
        },
        {
          id: 3,
          quote: 'Der Zugang zu EU-Fördermitteln wurde mit ihrer Expertenberatung unkompliziert. Sehr empfehlenswert.',
          author: 'Geschäftsführer',
          company: 'Berlin',
        },
      ],
    },
    insights: {
      sectionTag: 'Wissenszentrum',
      title: 'Markteinblicke',
      subtitle: 'Bleiben Sie informiert mit unseren neuesten Artikeln',
      articles: [
        {
          id: 1,
          title: 'Sacheinlagen und Holdingstrukturen',
          excerpt: 'Verstehen Sie Apport und wie Sie Ihre Holdingstruktur optimieren.',
          author: 'László Biró',
          date: '2025-01-15',
          readTime: '5 Min',
        },
        {
          id: 2,
          title: 'Kapitalbeschaffungsstrategien mit FlexCo',
          excerpt: 'Entdecken Sie innovative Ansätze zur Sicherung von Wachstumskapital.',
          author: 'Tibor Mészáros',
          date: '2025-01-10',
          readTime: '7 Min',
        },
        {
          id: 3,
          title: 'Eintritt in den DACH-Markt',
          excerpt: 'Ein umfassender Leitfaden für CEE-Unternehmen zur Expansion.',
          author: 'Dr. Ferenc Rosner',
          date: '2025-01-05',
          readTime: '6 Min',
        },
      ],
    },
    contact: {
      sectionTag: 'Kontakt',
      title: 'Starten Sie Ihre Reise',
      subtitle: 'Bereit, Ihr Geschäftspotenzial zu erschließen? Kontaktieren Sie uns.',
      form: {
        name: 'Vollständiger Name',
        email: 'E-Mail-Adresse',
        company: 'Firmenname',
        phone: 'Telefonnummer',
        message: 'Ihre Nachricht',
        submit: 'Nachricht senden',
        success: 'Vielen Dank! Wir werden Sie in Kürze kontaktieren.',
      },
      booking: {
        title: 'Beratung buchen',
        description: 'Vereinbaren Sie ein kostenloses 30-minütiges Beratungsgespräch.',
        cta: 'Jetzt planen',
      },
      info: {
        email: 'info@flexco.hu',
        phone: '+43 1 234 5678',
        address: 'Wien, Österreich',
      },
    },
    footer: {
      description: 'Ihr vertrauenswürdiger Partner für österreichische Firmengründung und Kapitalbeschaffung.',
      links: {
        services: 'Leistungen',
        about: 'Über uns',
        contact: 'Kontakt',
        privacy: 'Datenschutz',
        terms: 'AGB',
      },
      copyright: '© 2025 FlexCo Consulting. Alle Rechte vorbehalten.',
    },
  },
  hu: {
    nav: {
      home: 'Főoldal',
      services: 'Szolgáltatások',
      benefits: 'Előnyök',
      team: 'Csapat',
      insights: 'Piaci kitekintések',
      contact: 'Kapcsolat',
    },
    hero: {
      tagline: 'Kapuja az európai piacokhoz',
      title: 'Innovatív tőkemegoldások',
      subtitle: 'Az osztrák FlexCo-n keresztül',
      description: 'Szerezzen növekedési tőkét, EU-s forrásokat, és terjeszkedjen a német nyelvű piacokra szakértő tanácsadó csapatunkkal.',
      cta1: 'Konzultáció foglalás',
      cta2: 'Kapcsolatfelvétel',
    },
    services: {
      sectionTag: 'Amit kínálunk',
      title: 'Szolgáltatásaink',
      subtitle: 'Átfogó megoldások vállalkozása európai növekedéséhez',
      items: [
        {
          id: 1,
          icon: 'Building2',
          title: 'Cégalapítás',
          description: 'Alapítsa meg osztrák FlexCo-ját teljes jogi megfeleléssel és minimális adminisztrációval.',
        },
        {
          id: 2,
          icon: 'TrendingUp',
          title: 'Tőkebevonás',
          description: 'Hozzáférés innovatív UWA-alapú finanszírozáshoz a kontroll megtartása mellett.',
        },
        {
          id: 3,
          icon: 'Briefcase',
          title: 'Vállalati tanácsadás',
          description: 'Stratégiai útmutatás piacra lépéshez és üzletfejlesztéshez.',
        },
        {
          id: 4,
          icon: 'Target',
          title: 'Stratégiai tanácsadás',
          description: 'Személyre szabott stratégiák a fenntartható növekedésért.',
        },
        {
          id: 5,
          icon: 'FileCheck',
          title: 'Due Diligence',
          description: 'Átfogó pénzügyi, jogi és működési átvilágítás.',
        },
        {
          id: 6,
          icon: 'Handshake',
          title: 'M&A tanácsadás',
          description: 'Szakértői támogatás fúziókhoz és felvásárlásokhoz.',
        },
      ],
    },
    benefits: {
      sectionTag: 'Miért FlexCo',
      title: 'FlexCo előnyök',
      subtitle: 'Az innovatív osztrák cégforma a modern üzleti igényekhez',
      items: [
        { icon: 'Wallet', title: 'Alacsony törzstőke', description: 'Induljon minimális tőkekövetelménnyel' },
        { icon: 'Shield', title: 'Jogbiztonság', description: 'Osztrák jogrend védelme' },
        { icon: 'Globe', title: 'DACH piac elérés', description: 'Közvetlen hozzáférés a német nyelvű piacokhoz' },
        { icon: 'Euro', title: 'EU források elérése', description: 'Könnyebb hozzáférés európai finanszírozáshoz' },
        { icon: 'FileText', title: 'Egyszerűsített adminisztráció', description: 'Csökkentett bürokrácia' },
        { icon: 'Users', title: 'Rugalmas struktúra', description: 'Adaptálható vállalatirányítás' },
        { icon: 'PiggyBank', title: 'Adóelőnyök', description: 'Nincs iparűzési adó, kedvező egyezmények' },
        { icon: 'Zap', title: 'Gyors alapítás', description: 'Hatékony cégalapítás' },
      ],
      uwa: {
        tag: 'Innováció',
        title: 'UWA - A startup finanszírozás jövője',
        description: 'Az Unternehmenswert-Anteil (UWA) egy forradalmi értékalapú részesedés, amely rugalmas tőkebevonást tesz lehetővé az alapítók kontrolljának megőrzése mellett.',
        features: [
          'Közjegyző nélkül kibocsátható',
          'Maximum 50%-os szavazati plafon védi az alapítókat',
          'Független a törzstőke nagyságától',
          'Gyors és költséghatékony folyamat',
        ],
      },
    },
    team: {
      sectionTag: 'Szakértőink',
      title: 'Csapatunk',
      subtitle: 'Tapasztalt szakemberek az Ön sikeréért',
      members: [
        {
          id: 1,
          name: 'Mészáros Tibor',
          role: 'Nemzetközi forrásbevonás',
          description: 'Határon átnyúló finanszírozás és befektetői kapcsolatok szakértője',
        },
        {
          id: 2,
          name: 'Dr. Rosner Ferenc',
          role: 'Nemzetközi vállalati jog',
          description: 'Osztrák és EU üzleti jog specialista',
        },
        {
          id: 3,
          name: 'Biró László',
          role: 'Vezető vállalati szakértő',
          description: 'Senior tanácsadó stratégiai üzletfejlesztéshez',
        },
      ],
    },
    testimonials: {
      sectionTag: 'Sikertörténetek',
      title: 'Ügyfeleink véleménye',
      subtitle: 'Mit mondanak ügyfeleink a velünk való együttműködésről',
      items: [
        {
          id: 1,
          quote: 'A FlexCo Consulting segített 800.000 EUR növekedési tőkét bevonni, miközben megőriztük a teljes kontrollt. UWA szakértelmük páratlan.',
          author: 'Vezérigazgató, Tech Startup',
          company: 'Bécs',
        },
        {
          id: 2,
          quote: 'A csapat végigvezetett minket az osztrák jelenlétünk létrehozásának minden lépésén. Professzionális és hatékony.',
          author: 'Alapító',
          company: 'Budapest',
        },
        {
          id: 3,
          quote: 'Az EU-s források elérése egyszerűvé vált szakértői útmutatásukkal. Nagyon ajánlom minden CEE vállalatnak.',
          author: 'Ügyvezető igazgató',
          company: 'Berlin',
        },
      ],
    },
    insights: {
      sectionTag: 'Tudásközpont',
      title: 'Piaci kitekintések',
      subtitle: 'Maradjon tájékozott legújabb cikkeinkkel és elemzéseinkkel',
      articles: [
        {
          id: 1,
          title: 'Apport és Holding struktúra',
          excerpt: 'Értse meg az apportot és hogyan optimalizálhatja holding struktúráját.',
          author: 'Biró László',
          date: '2025-01-15',
          readTime: '5 perc',
        },
        {
          id: 2,
          title: 'Tőkebevonási stratégiák a FlexCo-val',
          excerpt: 'Fedezze fel az innovatív megközelítéseket a növekedési tőke megszerzéséhez.',
          author: 'Mészáros Tibor',
          date: '2025-01-10',
          readTime: '7 perc',
        },
        {
          id: 3,
          title: 'Belépés a DACH piacra',
          excerpt: 'Átfogó útmutató CEE vállalatoknak a német nyelvű piacokra való terjeszkedéshez.',
          author: 'Dr. Rosner Ferenc',
          date: '2025-01-05',
          readTime: '6 perc',
        },
      ],
    },
    contact: {
      sectionTag: 'Kapcsolat',
      title: 'Kezdje el útját',
      subtitle: 'Készen áll vállalkozása potenciáljának kiaknázására? Lépjen kapcsolatba velünk.',
      form: {
        name: 'Teljes név',
        email: 'E-mail cím',
        company: 'Cégnév',
        phone: 'Telefonszám',
        message: 'Üzenet',
        submit: 'Üzenet küldése',
        success: 'Köszönjük! Hamarosan felvesszük Önnel a kapcsolatot.',
      },
      booking: {
        title: 'Konzultáció foglalás',
        description: 'Foglaljon ingyenes 30 perces konzultációt szakértőinkkel.',
        cta: 'Foglalás most',
      },
      info: {
        email: 'info@flexco.hu',
        phone: '+43 1 234 5678',
        address: 'Bécs, Ausztria',
      },
    },
    footer: {
      description: 'Megbízható partnere az osztrák cégalapításban és tőkebevonásban.',
      links: {
        services: 'Szolgáltatások',
        about: 'Rólunk',
        contact: 'Kapcsolat',
        privacy: 'Adatvédelem',
        terms: 'Felhasználási feltételek',
      },
      copyright: '© 2025 FlexCo Consulting. Minden jog fenntartva.',
    },
  },
};

export const stats = [
  { value: '€50M+', label: { en: 'Capital Raised', de: 'Kapital beschafft', hu: 'Bevont tőke' } },
  { value: '100+', label: { en: 'Companies Formed', de: 'Gegründete Firmen', hu: 'Alapított cég' } },
  { value: '15+', label: { en: 'Years Experience', de: 'Jahre Erfahrung', hu: 'Év tapasztalat' } },
  { value: '98%', label: { en: 'Client Satisfaction', de: 'Kundenzufriedenheit', hu: 'Ügyfélelégedettség' } },
];
